import * as yup from 'yup'
import type { TranslationFunction } from '@/locales/types.ts'

export default (t: TranslationFunction) =>
yup.string().optional()
  /*
  .test(
    'is-valid-image-or-url',
    t('settings.validation.incorrectImageFormat'),
    value => {
      if (!value) return false;

      // If it starts with "data:image/", we check it as base64
      if (value.startsWith('data:image/')) {
        const base64Regex = /^data:image\/(jpeg|png|gif|jpg);base64,/;
        if (!base64Regex.test(value)) {
          return false;
        }
        const base64Data = value.split(',')[1];
        if (!base64Data) {
          return false;
        }

        try {
          atob(base64Data);
          return true;
        } catch (error) {
          console.error(error)
          return false;
        }
      } else {
        return true;

        // TODO: when BE wil be ready
        // try {
        //   new URL(value);
        //   return true;
        // } catch (error) {
        //   console.error(error)
        //   return false;
        // }
      }
    }
    );*/
